document.querySelectorAll('.brief-title-container').forEach(item => {
    item.addEventListener('click', (event) => {
        const BRIEF_CONTENT = event.target.parentElement.nextElementSibling;
        const BRIEF_TITLE = event.target.parentElement;

        if (BRIEF_CONTENT.classList.contains("brief-open")) {
            BRIEF_CONTENT.classList.remove("brief-open");
            BRIEF_TITLE.classList.remove("brief-open");
            BRIEF_CONTENT.setAttribute('aria-expanded', "false");
        } else {
            BRIEF_CONTENT.classList.add("brief-open");
            BRIEF_TITLE.classList.add("brief-open");
            BRIEF_CONTENT.setAttribute('aria-expanded', "true");
        }
    })
})




